import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

export default function AdminGeotaggingPage() {
    const { serverId, adminId } = useParams();
    const navigate = useNavigate();
    const [admin, setAdmin] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchAdmin() {
            try {
                const docRef = doc(db, 'servers', serverId, 'admins', adminId);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    setAdmin({ id: docSnap.id, ...docSnap.data() });
                }
            } catch (error) {
                console.error("Error fetching admin location:", error);
            } finally {
                setLoading(false);
            }
        }
        fetchAdmin();
    }, [serverId, adminId]);

    if (loading) return <div style={{ padding: 20 }}>Locating Admin...</div>;
    if (!admin) return <div style={{ padding: 20 }}>Admin not found.</div>;

    // Extract Location Data
    const location = admin.activeLocation || {};
    // Handle Firestore GeoPoint: it might be { latitude, longitude } or { _lat, _long } or an array
    const lat = location.geopoint?.latitude || location.geopoint?._lat || location.geopoint?.[0];
    const lng = location.geopoint?.longitude || location.geopoint?._long || location.geopoint?.[1];
    
    const hasLocation = lat && lng;
    const lastSeenDate = admin.lastSeen?.toDate ? new Date(admin.lastSeen.toDate()).toLocaleString() : 'Unknown';

    return (
        <div style={{ padding: '30px', backgroundColor: '#f4f6f8', minHeight: '100vh' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '30px' }}>
                <button onClick={() => navigate(-1)} style={{ marginRight: '20px', padding: '8px 16px', border: '1px solid #ddd', borderRadius: '4px', background: 'white', cursor: 'pointer' }}>← Back</button>
                <div>
                    <h1 style={{ margin: 0, fontSize: '24px', color: '#2c3e50' }}>Geotagging: {admin.fullName}</h1>
                    <p style={{ margin: '5px 0 0', color: '#666' }}>
                        Last Active: <strong>{lastSeenDate}</strong>
                    </p>
                </div>
            </div>

            <div style={{ backgroundColor: 'white', borderRadius: '8px', padding: '30px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
                <div style={{ fontSize: '48px', marginBottom: '10px' }}>📍</div>
                
                {hasLocation ? (
                    <>
                        <h2 style={{ margin: '10px 0', color: '#333' }}>Current Location Found</h2>
                        <p style={{ color: '#666', marginBottom: '25px' }}>
                            Coordinates: {lat}, {lng}<br />
                            <small>Geohash: {location.geohash || 'N/A'}</small>
                        </p>

                        <div style={{ height: '400px', backgroundColor: '#eee', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px', border: '2px solid #ddd', overflow: 'hidden' }}>
                            {/* Embed Google Maps View */}
                            <iframe 
                                width="100%" 
                                height="100%" 
                                frameBorder="0" 
                                style={{ border: 0 }} 
                                src={`https://maps.google.com/maps?q=${lat},${lng}&z=15&output=embed`}
                                title="Admin Location"
                            ></iframe>
                        </div>

                        <button 
                            onClick={() => window.open(`https://www.google.com/maps/search/?api=1&query=${lat},${lng}`, '_blank')}
                            style={{ padding: '12px 24px', backgroundColor: '#4299e1', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', fontSize: '16px' }}
                        >
                            Open in Google Maps App
                        </button>
                    </>
                ) : (
                    <>
                        <h2 style={{ color: '#e53e3e' }}>Location Unavailable</h2>
                        <p style={{ color: '#666' }}>
                            This admin has not shared their location yet or is currently offline with no cached location.
                        </p>
                    </>
                )}
            </div>
        </div>
    );
}